<script setup lang="ts">
	defineProps<{
		title: string
		desc?: string
	}>()
</script>

<template>
	<div>
		<div class="mx-auto flex min-h-[361px] w-full max-w-[438px] items-center justify-center bg-[#2D43792E]">
			<div
				class="flex min-h-[289px] w-full max-w-[360px] flex-col justify-center rounded-[4.78px] border bg-white px-10 py-3 text-center"
			>
				<h3 class="text-center text-xl font-medium text-primary-2">
					<slot name="title">
						{{ title }}
					</slot>
				</h3>
				<p class="mt-2 text-sm text-[#5F738C]">
					<slot name="desc">
						{{ desc }}
					</slot>
				</p>
			</div>
			<slot />
		</div>
	</div>
</template>
